import React from 'react';
import { useBusiness } from 'hooks/business/use-business';
import { Overview } from 'modules/dashboard/treasure-reserve';
import { BridgeReturnsOverview } from './bridge-returns-overview';

export const OverviewTransition = () => {
  const { data: business } = useBusiness();

  let isBridge = false;
  const legalName = business?.LegalName;
  if (legalName === 'Bridge Building Inc') {
    isBridge = true;
  }
  if (business?.Id === '6d514a50-1960-4e71-992f-5153d69b119a') {
    isBridge = true;
  }

  if (isBridge) {
    return <BridgeReturnsOverview />;
  }

  return <Overview />;
};
